import {ACTION_CODE} from './_actionCode';
import {AttachmentService} from '../../services';
import {ErrorModel, ResultModel} from '../../models';
import {LoggerService} from '../../services';
const FUNCTION_CODE = 'CREATE_ATTACHMENT';

export async function createAttachment(userData: Record<string, any>, payload: Record<string, any>) {
    try {
        LoggerService.logInfo('Action - createAttachment - Start');

        const createAttachmentResult = await AttachmentService.createAttachment(userData, payload);

        LoggerService.logInfo('Action - createAttachment - End - Success');

        return ResultModel.newSuccessResult(createAttachmentResult);
    }
    catch (error) {
        LoggerService.logInfo('Action - createAttachment - End - Error');

        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
